import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    //登录
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
}, {
    //登录
    path: '/saml2/login',
    name: 'login',
    component: () => import('../views/Login.vue')
}, {
    path: "/",
    redirect: "/index/entry",
},{
    path: "/index",
    redirect: "/index/entry",
},{
    //首页
    path: '/index',
    component: () => import( '../views/index/Index.vue'),
    children: [{
        //系统入口
        path: 'entry',
        name: 'entry',
        component: () => import( '../views/index/Entry.vue')
    },{
        //个人信息展示
        path: 'info',
        name: 'info',
        component: () => import( '../views/manage/Single.vue')
    },{
        //权限申请
        path: 'selfApply',
        name: 'selfApply',
        component: () => import( '../views/index/SelfApply.vue')
    },{
        //权限审核
        path: 'selfApproval',
        name: 'selfApproval',
        component: () => import( '../views/index/SelfApproval.vue')
    },{
        //申请统计
        path: 'oneAudit',
        name: 'oneAudit',
        component: () => import( '../views/index/OneAudit.vue')
    }]  
},{
    //管理页面
    path: '/manage',
    component: () => import( '../views/manage/Index.vue'),
    children: [{
        //用户管理
        path: 'user',
        name: 'user',
        component: () => import( '../views/manage/User.vue')
    },{
        //个人管理
        path: 'single',
        name: 'single',
        component: () => import( '../views/manage/Single.vue')
    },{
        //多邮箱配置
        path: 'email',
        name: 'email',
        component: () => import( '../views/manage/Email.vue')
    },{
        //系统管理
        path: 'system',
        name: 'system',
        component: () => import( '../views/manage/System.vue')
    },{
        //系统类别
        path: 'systemCategory',
        name: 'systemCategory',
        component: () => import( '../views/manage/systemCategory.vue')
    },{
        //角色管理
        path: 'role',
        name: 'role',
        component: () => import( '../views/manage/Role.vue')
    },{
        //菜单禁用
        path: 'menuDisabled',
        name: 'menuDisabled',
        component: () => import( '../views/manage/MenuDisabled.vue')
    },{
        //菜单管理
        path: 'menu',
        name: 'menu',
        component: () => import( '../views/manage/Menu.vue')
    }]
},{
    path: "*",
    beforeEnter: (to, from, next) => {
        next("/");
    },
}]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 重写路由的push方法，避免出现报错：Navigating to current location
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch((err) => err);
};

router.afterEach(() => {
    window.scrollTo(0, 0);
});

export default router